import { render, staticRenderFns } from "./advisor-card.vue?vue&type=template&id=d436f082"
import script from "./advisor-card.vue?vue&type=script&lang=ts"
export * from "./advisor-card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports